interface SolutionsDescriptionProps {
 animation: string
 bottom: string
 right?: string
 left?: string
 maxWidth: string
 description: string
}

export function SolutionsDescription({
 animation,
 bottom,
 right,
 left,
 maxWidth,
 description
}: SolutionsDescriptionProps) {
 return (
  <div
   className={`absolute animate__animated animate__${animation} animate__delay-900ms`}
   style={{
    bottom: `${bottom}px`,
    ...(right !== undefined && { right: `${right}px` }),
    ...(left !== undefined && { left: `${left}px` })
   }}
  >
   <p
    className="text-[var(--text-main)] font-normal text-[17px] font-['rns-milesregular']"
    style={{ maxWidth: `${maxWidth}px` }}
   >
    {description}
   </p>
  </div>
 )
}
